import { useQuery } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { CreditCustomerContext } from '@/types/customer-context'

export async function readCreditCustomerContext() {
  const response = await httpClient('financial').get<CreditCustomerContext>(
    '/v1/customer/context',
    { ignoreErrorToast: true },
  )

  return response.data
}

export function useCreditCustomerContext() {
  return useQuery({
    queryKey: ['customer-context', 'financial'],
    queryFn: readCreditCustomerContext,
    retry: 1,
  })
}
